// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__CI-3C","legacyBtn":"MutateMid_legacyBtn__Cqm6J"};